/** Utilities shared across LocumConnect pages. */

export const rupees = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

/** Build a wa.me deep-link from a stored +91 phone. Strips non-digits. */
export const waLink = (phone, prefill = "") => {
  if (!phone) return null;
  const digits = String(phone).replace(/\D/g, "");
  if (!digits) return null;
  const msg = prefill ? `?text=${encodeURIComponent(prefill)}` : "";
  return `https://wa.me/${digits}${msg}`;
};

export const APP_STATUS_STYLES = {
  applied: "bg-slate-100 text-slate-800",
  confirmed: "bg-emerald-100 text-emerald-800",
  declined: "bg-slate-100 text-slate-500",
  completed: "bg-indigo-100 text-indigo-800",
};

export const SHIFT_STATUS_STYLES = {
  open: "bg-emerald-100 text-emerald-800",
  confirmed: "bg-indigo-100 text-indigo-800",
  completed: "bg-slate-200 text-slate-700",
  cancelled: "bg-rose-100 text-rose-800",
};
